import gql from 'graphql-tag'

export const GET_TICKETS = gql`
  query getTickets(
    $where: TicketsWhereInput
    $skip: Int
    $limit: Int
    $sort: SortInput
  ) {
    getTickets(where: $where, skip: $skip, limit: $limit, sort: $sort) {
      tickets {
        id
        ticketNumber

        subject
        description
        isRead
        generatedBy {
          id
          firstName
          lastName
          role
          clientCode
          userName
        }
        status
        fileUrl
        assignUser {
          id
          firstName
          lastName
          role
        }
        closedByUser {
          id
          firstName
          lastName
          role
        }
        closedDate
        createdAt
        updatedAt
        reason
        isForClient
        generateFor {
          id
          firstName
          lastName
          email
          role
          clientCode
          userName
        }
        categoryName
        subCategoryName
        ticketLogs {
          status
          description
          fileUrl
          createdAt
          updatedAt
          statusChanger {
            id
            firstName
            lastName
            email
            phone
            role
          }
        }
      }
      count
      counters {
        totalTicket
        openTicket
        inProcessTicket
        closedTicket
        reOpenTicket
        pendingTicket
      }
    }
  }
`

export const GET_TICKET = gql`
  query getTicket($id: ID!) {
    getTicket(where: { id: $id }) {
      id
      ticketNumber
      subject
      description
      status
      closedDate
      fileUrl
      reason
      isRead
      generatedBy {
        id
        firstName
        lastName
        email
        phone
        address
        cityId
        stateId
        countryId
        motherName
        fatherName
        dateOfBirth
        userName
        isActive
        role
        keyId
        isAuto
        isAssociate
        fundReceived
        isKycDone
        completedSteps
        amcStartDate
        sipStartDate
        closedDate
        initialExposure
        clientCode
        strategyCode
        createdBy {
          id
        }
        updatedBy {
          id
        }
        token
        createdAt
        updatedAt
      }
      assignUser {
        id
        firstName
        lastName
        role
      }
      closedByUser {
        id
        firstName
        lastName
        role
      }
      isForClient
      generateFor {
        id
        firstName
        lastName
        email
        role
        clientCode
        userName
      }
      categoryName
      subCategoryName
      ticketLogs {
        status
        description
        fileUrl
        createdAt
        updatedAt
        statusChanger {
          id
          firstName
          lastName
          email
          phone
          role
        }
      }
      createdAt
      updatedAt
    }
  }
`

export const GET_MESSAGES_FOR_EXPORT = gql`
  query ChatMessagesForExport($ticketId: ID!, $type: ChatRoomType!) {
    chatMessagesForExport(ticketId: $ticketId, type: $type) {
      messages {
        id
        message
        attachments
        createdAt
        sender {
          id
          firstName
          lastName
        }
      }
    }
  }
`

export const GET_MESSAGES = gql`
  query ChatMessages(
    $ticketId: ID!
    $type: ChatRoomType!
    $offset: Int
    $limit: Int
  ) {
    chatMessages(
      ticketId: $ticketId
      type: $type
      offset: $offset
      limit: $limit
    ) {
      messages {
        id
        message
        chatRoomId
        attachments
        createdAt
        sender {
          id
          firstName
          lastName
        }
        mentions {
          id
          firstName
          lastName
        }
        status
        readBy {
          id
          firstName
          lastName
        }
      }
      room {
        id
        name
        ticketId
        type
        createdBy {
          id
          firstName
        }
      }
      attachments
      count
    }
  }
`

export const GET_CHAT_PARTICIPANTS = gql`
  query ChatParticipants($chatRoomId: ID!) {
    chatParticipants(chatRoomId: $chatRoomId) {
      id
      firstName
      lastName
    }
  }
`

export const GET_NEW_TICKETS = gql`
  query NewGetTickets(
    $where: newTicketsWhereInput
    $skip: Int
    $limit: Int
    $sort: SortInput
  ) {
    newGetTickets(where: $where, skip: $skip, limit: $limit, sort: $sort) {
      count
      counters {
        totalTicket
        openTicket
        closedTicket
        reOpenTicket
        inProcessTicket
        triagedTicket
        resolvedTicket
        escalatedTicket
        breachedTicket
      }
      tickets {
        assignUser {
          firstName
          lastName
          id
        }
        id
        ticketNumber
        department {
          id
          head {
            id
            firstName
            lastName
          }
          departmentName
        }
        priority {
          priorityLevel
          slaTime
          id
        }
        status
        description
        reason
        currentLevel
        ticketLogs {
          action
          status
          description
          fileUrl
          createdAt
          statusChanger {
            id
            firstName
            lastName
          }
        }
        duration
        createdAt
        closedDate
        fileUrl
        resolvedAt
        contactMode
        generateFor {
          id
          firstName
          lastName
          clientCode
          userName
        }
        generatedBy {
          id
          firstName
          lastName
          role
          clientCode
          userName
        }
        closedByUser {
          id
          firstName
          lastName
          role
        }
      }
    }
  }
`

export const GET_NEW_TICKET = gql`
  query newGetTicket($id: ID!) {
    newGetTicket(where: { id: $id }) {
      id
      ticketNumber
      subject
      description
      status
      closedDate
      contactMode
      contactDetail
      fileUrl
      reason
      isRead
      department {
        id
        head {
          firstName
          lastName
        }
        departmentName
      }
      priority {
        priorityLevel
        slaTime
        id
      }
      generatedBy {
        id
        firstName
        lastName
        email
        phone
        address
        cityId
        stateId
        countryId
        motherName
        fatherName
        dateOfBirth
        userName
        isActive
        role
        keyId
        isAuto
        isAssociate
        fundReceived
        isKycDone
        completedSteps
        amcStartDate
        sipStartDate
        closedDate
        initialExposure
        clientCode
        strategyCode
        createdBy {
          id
        }
        updatedBy {
          id
        }
        token
        createdAt
        updatedAt
      }
      assignUser {
        id
        firstName
        lastName
        role
      }
      closedByUser {
        id
        firstName
        lastName
        role
      }
      isForClient
      generateFor {
        id
        firstName
        lastName
        email
        role
        clientCode
        userName
      }
      categoryName
      subCategoryName
      currentLevel
      ticketLogs {
        status
        description
        fileUrl
        createdAt
        updatedAt
        statusChanger {
          id
          firstName
          lastName
          email
          phone
          role
        }
      }
      createdAt
      updatedAt
      duration
    }
  }
`

export const GET_PRIORITY_SLA_CONFIG = gql`
  query GetPrioritySlaConfigs {
    getPrioritySlaConfigs {
      id
      priorityLevel
      slaTime
      updatedBy
      updatedByUser {
        id
        firstName
        lastName
      }
      createdAt
      updatedAt
    }
  }
`
export const GET_TICKET_ANALYSIS = gql`
  query getTicketAnalysis {
    getTicketAnalysis
  }
`

export const GET_SLA_MONITORING = gql`
  query getSlaMonitoring(
    $timeRange: TimeRange!
    $customFrom: String
    $customTo: String
    $page: Int
    $limit: Int
  ) {
    getSlaMonitoring(
      timeRange: $timeRange
      customFrom: $customFrom
      customTo: $customTo
      page: $page
      limit: $limit
    )
  }
`
